import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { getAnalysisDatasetsV2 } from "@/api/analysis/analysisApi";
import { RootState } from "@/store";
import { EOutputAnalysisType } from "@/types/spatial";

import { useDataset } from "../map/useDataset";

export function useGetAnalysisDatasets(datasetId: string) {
  const { datasets } = useSelector((state: RootState) => state.dataset);
  const analysisId = useSelector(
    (state: RootState) => state.dataset.analysisId
  );

  const dataset = datasets[datasetId];

  const { addAnalysisDatasetGeometry } = useDataset();

  const shouldFetch =
    !!analysisId &&
    !!datasetId &&
    !!dataset?.properties?.isFetching &&
    ![EOutputAnalysisType.PROFILING, EOutputAnalysisType.GRID].includes(
      (dataset?.data?.spatial_aggregation_type ?? "") as EOutputAnalysisType
    );

  const { data, isSuccess, isError, refetch } = useQuery({
    queryKey: ["analysis-datasets", analysisId, datasetId],
    queryFn: () => getAnalysisDatasetsV2(analysisId || "", datasetId),
    enabled: shouldFetch
  });

  useEffect(() => {
    if (isSuccess && data?.result?.length) {
      addAnalysisDatasetGeometry(data.result[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, data?.result]);

  return { isError, refetch };
}
